import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatIconModule,
  MatRippleModule,
  MatTooltipModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
} from '@angular/material';
import { ClipboardModule } from 'ngx-clipboard';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { TextMaskModule } from 'angular2-text-mask';
import { ContextMenuModule } from 'ngx-contextmenu';

import { NgxExcelComponent } from './components/ngx-excel/ngx-excel.component';
import { NgxExcelColumnComponent } from './components/ngx-excel-column/ngx-excel-column.component';
import { NgxExcelContextActionComponent } from './components/ngx-excel-context-action/ngx-excel-context-action.component';
import { NgxExcelContextComponent } from './components/ngx-excel-context/ngx-excel-context.component';
import { NgxExcelCellComponent } from './components/ngx-excel-cell/ngx-excel-cell.component';
import { NgxExcelHeadCellComponent } from './components/ngx-excel-cell/ngx-excel-head-cell.component';
import { NgxExcelHandleCellComponent } from './components/ngx-excel-cell/ngx-excel-handle-cell.component';
import { NgxExcelNl2BrPipe } from './pipes/ngx-excel-nl2br.pipe';
import { NgxExcelMultiItemPipe } from './pipes/ngx-excel-multi-item.pipe';
import { NgxExcelSelectOptionPipe } from './pipes/ngx-excel-select-option.pipe';
import { NgxExcelDateTimePipe } from './pipes/ngx-excel-datetime.pipe';
import { NgxExcelCurrencyPipe } from './pipes/ngx-excel-currency.pipe';
import { NgxExcelWordCountPipe } from './pipes/ngx-excel-word-count.pipe';
import { NgxExcelComponentService } from './services/services';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatRippleModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    ClipboardModule,
    NgZorroAntdModule,
    TextMaskModule,
    ContextMenuModule,
  ],
  exports: [
    NgxExcelComponent,
    NgxExcelColumnComponent,
    NgxExcelContextActionComponent,

    NgxExcelContextComponent,

    NgxExcelCellComponent,
    NgxExcelHeadCellComponent,
    NgxExcelHandleCellComponent,

    NgxExcelNl2BrPipe,
    NgxExcelMultiItemPipe,
    NgxExcelSelectOptionPipe,
    NgxExcelDateTimePipe,
    NgxExcelCurrencyPipe,
    NgxExcelWordCountPipe,
  ],
  declarations: [
    NgxExcelComponent,
    NgxExcelColumnComponent,
    NgxExcelContextActionComponent,

    NgxExcelContextComponent,

    NgxExcelCellComponent,
    NgxExcelHeadCellComponent,
    NgxExcelHandleCellComponent,

    NgxExcelNl2BrPipe,
    NgxExcelMultiItemPipe,
    NgxExcelSelectOptionPipe,
    NgxExcelDateTimePipe,
    NgxExcelCurrencyPipe,
    NgxExcelWordCountPipe,
  ],
  providers: [
    NgxExcelComponentService
  ],
  entryComponents: [
    NgxExcelComponent
  ]
})
export class NgxExcelModule { }
